import { useAtom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { agentService } from '@/services';

/**
 * Atom with query for fetching agents
 */
const agentsAtom = atomWithQuery(() => ({
  queryKey: ['agents'],
  queryFn: agentService.getAgents,
  staleTime: 5 * 60 * 1000 // 5 minutes
}));

/**
 * Hook to fetch agents for the user's account
 */
export const useAgents = () => {
  return useAtom(agentsAtom);
};

